import { Button } from '@/components/ui'

interface ShowAllButtonProps {
  count: number
  noun: string
  onClick: () => void
}

export const ShowAllButton = ({ count, noun, onClick }: ShowAllButtonProps) => (
  <Button theme="outline" size="sm" className="w-fit" onClick={onClick}>
    Show all {count.toLocaleString('en-US')} {noun}
  </Button>
)
